import { render, staticRenderFns } from "./ContactCreds.vue?vue&type=template&id=89390e04&scoped=true&"
import script from "./ContactCreds.vue?vue&type=script&lang=js&"
export * from "./ContactCreds.vue?vue&type=script&lang=js&"
import style0 from "./ContactCreds.vue?vue&type=style&index=0&id=89390e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89390e04",
  null
  
)

export default component.exports